import React from 'react';
import { useTranslation } from 'react-i18next';
import './ImpactStats.css';

const ImpactStats: React.FC = () => {
  const { t } = useTranslation();
  
  const stats = [
    {
      number: t('impact.firstEdition.number'),
      label: t('impact.firstEdition.label'),
      description: t('impact.firstEdition.description')
    },
    {
      number: t('impact.participants.number'),
      label: t('impact.participants.label'),
      description: t('impact.participants.description')
    },
    {
      number: t('impact.partners.number'),
      label: t('impact.partners.label'),
      description: t('impact.partners.description')
    },
    {
      number: t('impact.globalReach.number'),
      label: t('impact.globalReach.label'),
      description: t('impact.globalReach.description')
    }
  ];

  return (
    <section className="impact-stats-section">
      <div className="container">
        <div className="stats-header text-center">
          <h2>{t('impact.title')}</h2>
          <p>{t('impact.subtitle')}</p>
        </div>
        
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className={`stat-card stat-card-${index % 4}`}>
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
              <div className="stat-description">{stat.description}</div>
            </div>
          ))}
        </div>
        
        <div className="stats-footer text-center">
          <p>
            {t('impact.footerText')}
          </p>
          <a href="/about" className="btn btn-outline">
            {t('common.learnMore')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ImpactStats;
